import { createSignal, type Signal } from "solid-js"
import { onCleanupDispose } from "../../../rx/cleanup/onCleanupDispose"
import createSharedCachedFactory from "../../../rx/memo/createSharedCachedFactory"
import { TextureWriter } from "../texture/TextureWriter.class"
import { getEngineThreeMainRenderer } from "./getSetEngineThreeMainRenderer"

const useEngineTextureWriter = createSharedCachedFactory<Signal<TextureWriter>>((engine) => {
  // console.log('getSetEngineWeakMapFactory<TextureWriter>')
  const renderer = getEngineThreeMainRenderer(engine)
  const textureWriter = new TextureWriter(renderer)
  // eslint-disable-next-line solid/reactivity
  const signal = createSignal<TextureWriter>(textureWriter)
  onCleanupDispose(textureWriter)
  return signal
})

export default useEngineTextureWriter
